<div *ngIf="!ordenSelected" class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->

<div *ngIf="ordenSelected" class="container-fluid">
  <form [formGroup]="agregarForm">
    <div class="row mb-2 p-3 border rounded">
      <div class="alert alert-secondary d-flex justify-content-between" role="alert">
        <div>Mantenimiento de Ordenes de Balanza</div>
        <div class="d-flex justify-content-end rounded bg-info px-3 text-white">ESTADO ORDEN BALANZA: {{ status }}
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza</label>
            <input class="form-control" formControlName="idOrden" name="idOrden" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('idOrden')?.hasError('required')">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Fecha</label>
            <input class="form-control" formControlName="fecha" name="fecha" readonly type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('idOrden')?.hasError('required')">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <!-- <label for="">Tipo de Orden</label> -->
            <!-- <input type="text" class="form-control" formControlName="tipo"> -->
            <label for="">Tipo de Orden</label>
            <select (ngModelChange)="onChangeTipo($event)" class="form-control" formControlName="tipo">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let data of cmbTipoOrden" [value]="data.id">{{ data.desca }}</option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('tipo')?.hasError('required')">
                  El campo Tipo de Orden es requerido.
                </div>
              </small>
            </div>
          </div>
          <div *ngIf="showNumeroDeOrden" class="col-lg-6 mb-2">
            <label for="">Número de Orden</label>
            <input (keypress)="keyNumeric($event)" class="form-control" formControlName="numero" name="numero"
              type="text">
            <div class="text-muted">
              <small><small>Compra/Venta, Traslados, Maquila</small></small>
            </div>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('numero')?.hasError('required')">
                  El campo Número de Orden es requerido.
                </div>
              </small>
            </div>
          </div>
          <div *ngIf="this.showIngresoVacio" class="col-lg-6 mb-2 d-flex">
            <label class="mb-2" for="emptyIncome" style="margin-right: 15px;">
              Ingreso Vacio
            </label>
            <div class="form-check">
              <input (change)="validaciones()" class="form-check-input" formControlName="emptyIncome" id="emptyIncome"
                type="checkbox">
              <label class="form-check-label" for="emptyIncome">
                {{this.agregarForm.get('emptyIncome') && this.agregarForm.get('emptyIncome').value ? 'Si' : 'No'}}
              </label>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <app-lfsa-input [addon]="false" [control]="agregarForm.get('freightNumber') | formControl"
              [id]="'freightNumber'" [isReadOnly]="true" [label]="'Número de Flete'" [mostrarImg]="false"
              [placeholder]="'Número de Flete'" [rutaImagen]="" [type]="'text'" formControlName="freightNumber">
            </app-lfsa-input>
          </div> -->


          <div class="col-lg-6 mb-2">
            <label for="">Factura</label>
            <input class="form-control" formControlName="factura" name="factura" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('factura')?.hasError('required')">
                  El campo Factura es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Guía</label>
            <input (keypress)="keyAlphaNumeric($event)" class="form-control" formControlName="guia" name="guia"
              type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('guia')?.hasError('required')">
                  El campo Guía es requerido.
                </div>
              </small>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <label for="">Proveedor</label>
            <input class="form-control" formControlName="proveedor" name="proveedor" type="text">
            <div
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('proveedor')?.hasError('required')">
                  El campo Proveedor es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keyup)="onChangeProveedor($event);" autocomplete="off"
                class="form-control" formControlName="proveedor" name="proveedor" type="text">
            </div>
            <div *ngIf="proveedorInvalido" class="text-danger">
              <small>*Este proveedor es inválido</small>
            </div>
            <small class="text-danger">
              <div *ngIf="agregarForm.get('proveedor')?.hasError('required')">
                El campo proveedor es requerido.
              </div>
            </small>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                type="text">
            </div>
          </div>

          <!-- <div class="col-lg-6 mb-2">
            <label for="">Cliente</label>
            <input class="form-control" formControlName="cliente" name="cliente" type="text">
            <div
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('cliente')?.hasError('required')">
                  El campo Cliente es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Cliente</label>
              <input (change)="onChangeCliente($event);" (keyup)="onChangeCliente($event);" autocomplete="off"
                class="form-control" formControlName="cliente" name="cliente" type="text">
            </div>
            <div *ngIf="clienteInvalido" class="text-danger">
              <small>*Este cliente es inválido</small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Cliente</label>
              <input autocomplete="off" class="form-control" formControlName="descli" name="descli" readonly
                type="text">
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza Origen</label>
            <input class="form-control" formControlName="ordBalanzaOrigen" name="ordBalanzaOrigen" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('ordBalanzaOrigen')?.hasError('required')">
                  El campo Orden de Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Peso de O.Balanza Origen</label>
            <input class="form-control" formControlName="pesoBalanzaOrigen" name="pesoBalanzaOrigen" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('pesoBalanzaOrigen')?.hasError('required')">
                  El campo Peso de O.Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Sellos</label>
            <input (keypress)="keyAlphaNumericCommaHyphen($event)" class="form-control" formControlName="sellos"
              name="sellos" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('sellos')?.hasError('required')">
                  El campo Sellos es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Contenedor/Recurso</label>
            <input (keypress)="keyAlphaNumeric($event)" class="form-control" formControlName="contenedor"
              name="contenedor" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('contenedor')?.hasError('required')">
                  El campo Contenedor es requerido.
                </div>
                <div *ngIf="agregarForm.get('contenedor')?.hasError('pattern')">
                  *Máximo 12 caracteres
                </div>
              </small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Material</label>
              <input (change)="onChangeMaterial($event)" (keyup)="onChangeMaterial($event);" autocomplete="off"
                class="form-control" formControlName="material" name="material" type="text" required>
              <div *ngIf="materialInvalido" class="text-danger">
                <small>*Este material es inválido</small>
              </div>
              <small class="text-danger">
                <div *ngIf="agregarForm.get('material')?.hasError('required')">
                  El campo material es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-2">
              <label for="">Desc. Material</label>
              <input autocomplete="off" class="form-control" formControlName="desmat" name="desmat" readonly
                type="text">
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row border">
          <div class="text-center border-bottom py-1">
            INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
          </div>
          <div class="row py-3">
            <div class="col-lg-6 mb-2">
              <label for="">Digite Ticket Autorización</label>
              <input class="form-control" formControlName="ticketAuth" name="ticketAuth" type="text">
              <button (click)="digiteTicketAutorizacionValidDuplicated()" *ngIf="isCreate" class="btn btn-success" type="button">
                Buscar </button>
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('ticketAuth')?.hasError('required')">El campo Ticket Autorización Transporte es requerido.</div>
                  <div *ngIf="agregarForm.get('placa').value === null">El campo Ticket Autorización debe ser validado.</div>
                </small>
              </div>
              <small *ngIf="digiteTicketAutorizacionDuplicated" class="text-danger">
                <div>
                  Este código de Ticket Autorización ya fue registrado.
                </div>
              </small>
            </div>
            <div class="col-lg-6 mb-2">
              <!-- <button *ngIf="isCreate" (click)="buscarPlacaTransporte()" type="button"
                class="btn btn-success">Buscar</button> -->
              <label for="">Placa</label>
              <input class="form-control" formControlName="placa" name="placa" type="text" id="placa">
              <div class="text-danger">
                <small>  <div *ngIf="digiteTicketAutorizacionDuplicated">  El campo Digite Placa es requerido. </div> </small>
              </div>

              <div *ngIf="agregarForm.get('placa')?.hasError('required')" class="text-danger"><small>*Este campo es requerido</small></div>

            </div>
            <div class="mb-2  ">
              <label for="">Datos Transportista</label>
            </div>
            <div class="col-lg-6 mb-2">
              <label for="">Chofer</label>
              <input class="form-control" formControlName="chofer" name="chofer" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('chofer')?.hasError('required')">
                    El campo Chofer es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Cédula</label>
              <input class="form-control" formControlName="cedChofer" name="cedChofer" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('cedChofer')?.hasError('required')">
                    El campo Cédula es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-2 mb-2 d-flex justify-content-start align-items-end">
              <button (click)="openModal()" [disabled]="!placaResponse?.codigo" class="btn btn-info text-white"
                type="button">Ver <i aria-hidden="true" class="fa fa-eye"></i></button>
            </div>
            <div class="col-lg-12">
              <label for="">Proveedor de Transporte</label>
              <input class="form-control" formControlName="provTransporte" id="provTransporte" name="provTransporte" type="text">
            </div>
          </div>
        </div>
        <div class="row border mt-3 py-3">
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            ORIGEN
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro</label>
            <select class="form-control" formControlName="centroOri" name="centroOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.idCentro}} - {{cen.nombreCentro}}
              </option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('centroOri')?.hasError('required')">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almanceOri" name="almanceOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almaceOriCmb" [value]="alm.idAlmacen">{{alm.idAlmacen}} - {{alm.dscaAlmacen}}
              </option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('almanceOri')?.hasError('required')">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            DESTINO
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro</label>
            <select class="form-control" formControlName="centroDest" name="centroDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.idCentro}} - {{cen.nombreCentro}}
              </option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('centroDest')?.hasError('required')">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almaceDest" name="almaceDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almaceDestCmb" [value]="alm.idAlmacen">{{alm.idAlmacen}} - {{alm.dscaAlmacen}}
              </option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="agregarForm.get('almaceDest')?.hasError('required')">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3" role="alert">
        Datos recibidos del proveedor
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="border-bottom mb-2">DATOS RECIBIDOS</div>
          <div class="row">
            <div class="col-lg-3 mb-2">
              <label>Origen</label>
              <select class="form-control" (change)="onChangeOrigen();" formControlName="origOrd" name="tipo">
                <option value="">-- Seleccione --</option>
                <option *ngFor="let origen of origenesExtractoras" [value]="origen.id">{{origen.id}} -
                  {{origen.descripcion}}</option>
              </select>
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('origOrd')?.hasError('required')">
                    El campo Origen es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="pesoBruto">Peso bruto</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoBruto" name="pesoBruto" type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('pesoBruto')?.hasError('required')"> El campo Peso bruto es requerido.</div>
                  <div *ngIf="agregarForm.get('pesoBruto')?.hasError('maxlength')">Máximo 5 caracteres.</div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="pesoNeto">Peso neto</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoNeto" name="pesoNeto" type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('pesoNeto')?.hasError('required')">El campo Peso neto es requerido.</div>
                  <!--<div *ngIf="agregarForm.get('pesoNeto').value<0"> El campo Peso neto debe ser mayor que cero. </div> -->
                  <div *ngIf="agregarForm.get('pesoNeto')?.hasError('maxlength')">Máximo 5 caracteres.</div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="tara">Peso Tara</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="tara" name="tara" type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('tara')?.hasError('required')"> El campo Tara es requerido.</div>
                  <div *ngIf="agregarForm.get('tara')?.hasError('maxlength')">Máximo 5 caracteres.</div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="border-bottom mb-2">CALIDAD RECIBIDA</div>
          <div class="row">
            <div class="col-lg-4 mb-2">
              <label for="">Acidez</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="acidez" name="acidez"
                type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('acidez')?.hasError('required')">
                    El campo Acidez es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Humedad</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="humedad" name="humedad"
                type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('humedad')?.hasError('required')">
                    El campo Humedad es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Impureza</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="impureza" name="impureza"
                type="text" maxlength="5">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('impureza')?.hasError('required')">
                    El campo Impureza es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3 d-flex" role="alert">
        <div class="w-60 d-flex align-items-center">
          <span> Orden de Compra SAP (solo aplica para la generación automatica de ordenes de compra) </span>
        </div>
        <div class="w-40 d-flex justify-content-end align-items-center" *ngIf="status == 'ERROR_COMUNICACION'">
          <button (click)="reenvioOC()" class="btn btn-info" style="color: white" type="button" [disabled]="agregarForm.invalid">
            Reenviar
          </button>
        </div>
      </div>
      <div class="row border m-0">
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('ocStatus') | formControl" [id]="'ocStatus'"
            [isReadOnly]="true" [label]="'ESTADO'" [mostrarImg]="false" [placeholder]="'ESTADO'" [rutaImagen]=""
            [type]="'text'" formControlName="ocStatus">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('solpedNumber') | formControl"
            [id]="'solpedNumber'" [isReadOnly]="true" [label]="'N# SOLPED'" [mostrarImg]="false"
            [placeholder]="'N# SOLPED'" [rutaImagen]="" [type]="'text'" formControlName="solpedNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('ocNumber') | formControl" [id]="'ocNumber'"
            [isReadOnly]="true" [label]="'N# OC'" [mostrarImg]="false" [placeholder]="'N# OC'" [rutaImagen]=""
            [type]="'text'" formControlName="ocNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('creationDateOC') | formControl"
            [id]="'creationDateOC'" [isReadOnly]="true" [label]="'FECHA CREACION'" [mostrarImg]="false"
            [placeholder]="'FECHA CREACION'" [rutaImagen]="" [type]="'text'" formControlName="creationDateOC">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('updateDateOC') | formControl"
            [id]="'updateDateOC'" [isReadOnly]="true" [label]="'FECHA ACTUALIZACION'" [mostrarImg]="false"
            [placeholder]="'FECHA ACTUALIZACION'" [rutaImagen]="" [type]="'text'" formControlName="updateDateOC">
          </app-lfsa-input>
        </div>
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información del lote de inspección
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="">
          <label for="">Número Lote</label>
          <input class="form-control" formControlName="loteInsp" name="loteInsp" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('loteInsp')?.hasError('required')">
                El campo Número Lote es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="">
          <label for="">GRADO API</label>
          <input (keypress)="keyDecimals($event)" class="form-control" formControlName="gradoApi" name="gradoApi"
            type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('gradoApi')?.hasError('required')">
                El campo GRADO API es requerido.
              </div>
            </small>
          </div>
        </div>

        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotAcidity') | formControl"
            [id]="'inspectionLotAcidity'" [isReadOnly]="true" [label]="'Acidez'" [mostrarImg]="false"
            [placeholder]="'Acidez'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotAcidity">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotMoisture') | formControl"
            [id]="'inspectionLotMoisture'" [isReadOnly]="true" [label]="'Humedad'" [mostrarImg]="false"
            [placeholder]="'Humedad'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotMoisture">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotImpurity') | formControl"
            [id]="'inspectionLotImpurity'" [isReadOnly]="true" [label]="'Impureza'" [mostrarImg]="false"
            [placeholder]="'Impureza'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotImpurity">
          </app-lfsa-input>
        </div>

        <div class="">
          <label for="">Decisión de Empleo</label>
          <input class="form-control" formControlName="decisionEmpleo" name="decisionEmpleo" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('decisionEmpleo')?.hasError('required')">
                El campo Decisión de Empleo es requerido.
              </div>
            </small>
          </div>
        </div>
        <!-- <div class="">
          <label for="">Estatus de calidad</label>
          <input class="form-control" formControlName="calidad" name="calidad" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('calidad')?.hasError('required')">
                El campo Estatus de calidad es requerido.
              </div>
            </small>
          </div>
        </div> -->
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Captura de pesos Entrada/Salida
        <div *ngIf="agregarForm.get('idOrden').value != null && tipoDeOrden == 0" style="float: right;">
          <div style="position: absolute;width: 150px;right: 12px;top: 13px;">
            <button (click)="imprimirEtiqueta()" class="btn btn-success btn-sm" type="button">Imprimir etiqueta
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS ENTRADA</div>
            <div>
              <i (click)="imprimirCapturaEntrada()" *ngIf="!imprimirCapturaEntradaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaEntradaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha entrada</label>
                  <input class="form-control" formControlName="fechIn" name="fechIn" type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('fechIn')?.hasError('required')">
                        El campo Fecha entrada de calidad es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora entrada</label>
                  <input class="form-control" formControlName="horaEntrada" name="horaEntrada" type="time">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('horaEntrada')?.hasError('required')">
                        El campo Hora entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso entrada</label>
                  <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoIn" name="pesoIn"
                    type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('pesoIn')?.hasError('required')">
                        El campo Peso entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
                <button (click)="capturaDePesoEntrada()" *ngIf="isCreate" [disabled]="capturaPesoInAction"
                  class="btn btn-success" type="button">Capturar
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-6 px-3">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS SALIDA</div>
            <div>
              <i (click)="imprimirCapturaSalida()" *ngIf="!imprimirCapturaSalidaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaSalidaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha salida</label>
                  <input class="form-control" formControlName="fechOut" name="fechOut" type="text">
                  <div
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('fechOut')?.hasError('required')">
                        El campo Fecha salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora salida</label>
                  <input class="form-control" formControlName="horaSalida" name="horaSalida" type="time">
                  <div
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('horaSalida')?.hasError('required')">
                        El campo Hora salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso salida</label>
                  <input (keypress)="keyNumeric($event)" class="form-control" formControlName="pesoOut" name="pesoOut"
                    type="text">
                  <div
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.get('pesoOut')?.hasError('required')">
                        El campo Peso salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
                <button (click)="capturaDePesoSalida()" *ngIf="isCreate" class="btn btn-success" type="button">Capturar
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información de la Balanza
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">SU BALANZA</label>
              <input class="form-control" formControlName="ordenFijaDescription" name="ordenFijaDescription" readonly
                type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('ordenFijaDescription')?.hasError('required')">
                    El campo SU BALANZA es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">USUARIO ACTUAL</label>
              <input class="form-control" formControlName="usuario" name="usuario" readonly type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('usuario')?.hasError('required')">
                    El campo USUARIO ACTUAL es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <button (click)="regresar()" *ngIf="!isCreate" class="btn btn-success">Regresar</button>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [class.d-none]="!isCreate"
      [formularioValido]="agregarForm.invalid" [loading]="loading" [textBoton]="'Guardar'" class="row"
      [mostrarBotonVerde]="!capturaPesoInAction">
    </app-lfsa-botones-formulario>
  </form>
</div>
<!-- END MODAL -->

<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'fillOne'" [idOpen]="'Modal'" [idClose]="'cerrarModalPeso'"
  [innTemplate]="abrirModalPeso" [titulo]="'PESO CAPTURADO'"></app-lfsa-modal>
<ng-template #abrirModalPeso>
  <div class="container-fluid">
    <div class="row">
      <form [formGroup]="fomularioPeso" novalidate class="form-group">
        <div [class]="'col-md-12'">
          <!--[isReadOnly]="true"-->
          <app-lfsa-input (change)="onChangePeso();" (keyup)="onChangePeso();" [claseLabel]="'letrasDanger'"
            [mostrarImg]="false" [rutaImagen]="" [control]="fomularioPeso.get('pesoBalanza')" [placeholder]="'0.0'"
            formControlName="pesoBalanza" [label]="'PESO'" [type]="'number'" [id]="'pesoBalanza'">
          </app-lfsa-input>
        </div>
        <div class="row">
          <div [class]="'col-lg-6'">
            <div *ngIf="!loading">
              <label>&nbsp;</label>
              <button class="btn btn-danger btn-block" (click)="cerrarModalPeso()">Cerrar</button>
            </div>
          </div>
          <div [class]="'col-lg-6'">
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <div *ngIf="!loading">
              <label>&nbsp;</label>
              <button class="btn btn-success btn-block" [disabled]="agregarForm.invalid"
                (click)="guardarCrearNueva()">Aceptar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'"
  [innTemplate]="abrirModalAgregarGarita" [idOpen]="'Modal2'" [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalAgregarGarita>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <label for="codigo">Código</label>
        <input [value]="placaResponse?.codigo" class="form-control" disabled id="codigo" name="codigo" type="text">
      </div>
      <div class="col-lg-6">
        <label for="placa">Placa</label>
        <input [value]="placaResponse?.placa" class="form-control" disabled id="placa" name="placa" type="text">
      </div>
      <div class="col-lg-6">
        <label for="cedula">Cedula</label>
        <input [value]="choferResponse?.cedula" class="form-control" disabled id="cedula" name="cedula" type="text">
      </div>
      <div class="col-lg-6">
        <label for="marca">Marca</label>
        <input [value]="placaResponse?.marca" class="form-control" disabled id="marca" name="marca" type="text">
      </div>
      <div class="col-lg-12">
        <label for="chofer">Chofer</label>
        <input [value]="choferResponse?.chofer" class="form-control" disabled id="chofer" name="chofer" type="text">
      </div>
    </div>
  </div>
</ng-template>
<!-- END MODAL -->
